export default "__VITE_ASSET__jLGmREz___"